import { memberGQLFields } from '../network/member.fields.js';
import { reactionGQLFields } from './reaction.fields.js';
const BASIC_POST_REACTION_PARTICIPANTS_FIELDS = {};
const ALL_POST_REACTION_PARTICIPANTS_FIELDS = {
    participant: 'basic',
    reaction: {
        fields: 'basic',
        variables: {
            limit: 25,
        },
    },
};
export const postReactionParticipantsGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_POST_REACTION_PARTICIPANTS_FIELDS;
    if (fields === 'all')
        fields = ALL_POST_REACTION_PARTICIPANTS_FIELDS;
    return `
    __typename
    ${fields.participant
        ? `
      participant {
        ${memberGQLFields(fields.participant)}
      }
    `
        : ``}
    ${fields.reaction
        ? `
      reaction {
        ${reactionGQLFields(fields.reaction)}        
      }
    `
        : ``}
  `;
};
//# sourceMappingURL=post-reaction-participant.fields.js.map